import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(() => ({
  message: {
    padding: '60px'
  }
}));